/** The 11-character video id from any common YouTube URL (watch, youtu.be, shorts, embed, live), or null. */
export function youTubeId(url: string): string | null {
  const match = url
    .trim()
    .match(
      /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{11})/
    )
  return match?.[1] ?? null
}
